import React from 'react';
import { CircleCheck, KeyRound } from 'lucide-react';
import { StorageUnit } from '../../types/storageUnits';
import { translateStorageUnitType } from '../../types/EnumTranslations';
import { STORAGE_UNIT_ICON, isUnitRented } from '../../Helpers/storageUnitUtils';

interface StorageUnitListProps {
    units: StorageUnit[];
    selectedUnitKey: string | null;
    /** Drawing key used to flag units without a marker on the level's current drawing. */
    currentBlueprintKey?: string;
    onSelect: (unitKey: string) => void;
}

const StorageUnitList: React.FC<StorageUnitListProps> = ({ units, selectedUnitKey, currentBlueprintKey, onSelect }) => {
    if (units.length === 0) {
        return <p style={{ color: '#999', margin: 0 }}>Inga förråd registrerade på denna våning.</p>;
    }

    return (
        <ul className="storage-unit-list">
            {units.map(unit => {
                const unplaced = !!currentBlueprintKey && !unit.blueprintLocations?.[currentBlueprintKey];
                return (
                    <li
                        key={unit.key}
                        className={`storage-unit-row ${selectedUnitKey === unit.key ? 'storage-unit-row--selected' : ''}`}
                        onClick={() => onSelect(unit.key)}
                    >
                        {/* One icon for every type, as on the drawing; the type is the text after the number */}
                        <img className="storage-unit-icon" src={STORAGE_UNIT_ICON} alt="" aria-hidden="true" />
                        <span className="storage-unit-number">{unit.number || '?'}</span>
                        <span className="storage-unit-meta">
                            {translateStorageUnitType(unit.type)}{unit.area ? ` · ${unit.area.toLocaleString('sv-SE', { maximumFractionDigits: 1 })} m²` : ''}
                        </span>
                        {unplaced && <span className="storage-badge storage-badge--warning">Ej placerad</span>}
                        {isUnitRented(unit)
                            ? <span className="storage-badge storage-badge--muted"><KeyRound size={12} aria-hidden="true" />Uthyrd</span>
                            : <span className="storage-badge storage-badge--success"><CircleCheck size={12} aria-hidden="true" />Ledig</span>}
                    </li>
                );
            })}
        </ul>
    );
};

export default StorageUnitList;
